// Generated by scripts/mdi/import-questionnaires.mjs from MDI "KPV 09.17.26" (76a24250-0a47-4c40-bdb3-9cdc68db45e1). Re-run instead of editing.
import { QuestionAnswerMap } from '@care-portals/api-interfaces';

const mdiKPVQuestions = [
  {
    field: 'mdiKPV_sex',
    label: 'What was your sex assigned at birth?',
    type: 'select',
    extras: { sendToBeluga: false, sendToMdi: false, mdiRouting: true },
    answer: {
      type: 'single_select',
      options: [
        { key: 'male', value: 'Male' },
        { key: 'female', value: 'Female' }
      ]
    }
  },
  {
    field: 'mdiKPV_pregnancy',
    label: 'Are you currently pregnant?',
    type: 'select',
    extras: { sendToBeluga: false, mdiRouting: true },
    answer: {
      type: 'single_select',
      options: [
        { key: 'yes', value: 'Yes' },
        { key: 'no', value: 'No' }
      ]
    }
  },
  {
    field: 'mdiKPV_wereSorryBasedPreviousAnswer',
    label:
      "We're sorry, based on a previous answer, this treatment is not medically appropriate for you at this time.",
    type: 'info',
    answer: {},
    class: 'ineligible',
    reject: true,
    blockQuestionFlow: true,
    isLast: true,
    extras: {
      mdiQuestionId: '7030c1be-aef0-48aa-999b-83b414886054',
      sendToBeluga: false,
      sendToMdi: false
    }
  },
  {
    field: 'mdiKPV_importantClickAttachedLinkReview',
    label:
      'IMPORTANT: Please click the attached link to review the consent for your peptide therapy treatment plan. By typing your name into the signature field you are attesting that you have read and understand this consent in its entirety.',
    type: 'info',
    subLabel:
      'Please click this link to view the Peptide therapy consent (https://drive.google.com/file/d/1aC4s0RdUTNdfhOIqOlA6BevX5CX02SI0/view)',
    answer: {
      type: 'text',
      name: 'mdiKPV_importantClickAttachedLinkReview',
      placeholder: 'Type your full legal name to proceed'
    },
    extras: { mdiQuestionId: '950e9df6-adaf-45c6-8dbe-7e07d78bbb7d' }
  },
  {
    field: 'mdiKPV_reasonInterestedPeptide',
    label: 'What is the reason you are interested in this peptide?',
    type: 'select',
    educationalSlide: 'Select all that apply',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'inflammatory_bowel_disease_ibd_ulcerativ',
          value:
            "Inflammatory bowel disease (IBD): ulcerative colitis and Crohn's disease"
        },
        {
          key: 'irritable_bowel_syndrome_ibs_with_inflam',
          value: 'Irritable bowel syndrome (IBS) with inflammatory component'
        },
        {
          key: 'gut_permeability_issues_leaky_gut',
          value: 'Gut permeability issues ("leaky gut")'
        },
        {
          key: 'chronic_inflammatory_conditions_arthriti',
          value:
            'Chronic inflammatory conditions (arthritis, joint inflammation)'
        },
        { key: 'immune_system_benefits', value: 'Immune system benefits' },
        {
          key: 'allergic_responses_and_mast_cell_activat',
          value: 'Allergic responses and mast cell activation'
        },
        {
          key: 'post_surgical_inflammation_and_recovery',
          value: 'Post-surgical inflammation and recovery'
        },
        {
          key: 'chronic_pain_associated_with_inflammatio',
          value: 'Chronic pain associated with inflammation'
        },
        {
          key: 'autoimmune_related_inflammation',
          value: 'Autoimmune-related inflammation'
        },
        {
          key: 'respiratory_inflammation_bronchial_epith',
          value: 'Respiratory inflammation (bronchial epithelial cells)'
        },
        {
          key: 'general_systemic_inflammation_reduction',
          value: 'General systemic inflammation reduction'
        }
      ]
    },
    extras: { mdiQuestionId: '77ba6eb0-4d51-4a77-9ec3-7f5c5013577d' }
  },
  {
    field: 'mdiKPV_everUsedPeptideTherapiesPast',
    label: 'Have you ever used peptide therapies in the past?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'yes', value: 'Yes' },
        { key: 'no', value: 'No' }
      ]
    },
    extras: { mdiQuestionId: '434ea40a-aeae-4737-9b30-bbbc86bf12fb' }
  },
  {
    field: 'mdiKPV_peptidesUsedPreviously',
    label: 'What peptides have you used previously?',
    type: 'info',
    answer: { type: 'text', name: 'mdiKPV_peptidesUsedPreviously', rows: 4 },
    extras: { mdiQuestionId: '75e0e655-1795-4bc3-ba3f-761c7f067f83' }
  },
  {
    field: 'mdiKPV_everReactionSideEffectsPeptide',
    label:
      'Have you ever had a reaction or side effects to peptide therapies in the past?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'yes', value: 'Yes' },
        { key: 'no', value: 'No' }
      ]
    },
    extras: { mdiQuestionId: '3b53804d-5972-4db2-92a4-80367cbc500d' }
  },
  {
    field: 'mdiKPV_reactionSideEffect',
    label: 'What was your reaction or side effect?',
    type: 'info',
    answer: { type: 'text', name: 'mdiKPV_reactionSideEffect', rows: 4 },
    extras: { mdiQuestionId: '9b5611fc-9ea9-436a-9281-c0e307e63197' }
  },
  {
    field: 'mdiKPV_diagnosedRedFlagMedicalConditions',
    label:
      'Do you currently have or have you been diagnosed with any of the following red flag medical conditions listed below that may disqualify you from treatment?',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'cancer', value: 'Cancer' },
        {
          key: 'cardiovascular_disease_heart_attack_stro',
          value:
            'Cardiovascular disease (heart attack, stroke, heart failure, etc)'
        },
        { key: 'immunocompromised', value: 'Immunocompromised' },
        { key: 'organ_transplant', value: 'Organ transplant' },
        { key: 'psychiatric_disorder', value: 'Psychiatric disorder' },
        { key: 'kidney_disease', value: 'Kidney disease' },
        { key: 'liver_disease', value: 'Liver disease' },
        { key: 'other_please_specify', value: 'Other (please specify)' },
        { key: 'none_of_these_apply_to_me', value: 'None of these apply to me' }
      ]
    },
    extras: { mdiQuestionId: 'a4357518-37ef-4cb1-8223-9a0eadb5bf69' }
  },
  {
    field: 'mdiKPV_confirmNotHistoryCancerKidney',
    label:
      'Please confirm you do not have any history of cancer, kidney or liver disease:',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'i_agree_i_do_not_have_any_history_of_can',
          value:
            'I agree, I do NOT have any history of cancer, kidney or liver disease'
        },
        {
          key: 'i_have_been_diagnosed_with_cancer_or_hav',
          value:
            'I HAVE been diagnosed with cancer or have had problems with my kidneys or liver previously'
        }
      ]
    },
    extras: { mdiQuestionId: '1c2452aa-f908-4325-b1c3-40aa9cbecca2' }
  },
  {
    field: 'mdiKPV_takeRedFlagMedicationsSubstances',
    label:
      'Do you take any of the following red flag medications or substances that may disqualify you from treatment?',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'corticosteroids_like_prednisone_dexameth',
          value: 'Corticosteroids (like prednisone, dexamethasone, etc)'
        },
        { key: 'anti_tnf_medications', value: 'Anti-TNF medications' },
        { key: 'anti_il_6_medications', value: 'Anti-IL-6 medications' },
        { key: 'jak_inhibitors', value: 'JAK inhibitors' },
        { key: 'none_of_the_above', value: 'None of the above' }
      ]
    },
    extras: { mdiQuestionId: '884becf5-178b-4cf5-9822-daf1501f4822' }
  },
  {
    field: 'mdiKPV_allergyBenzylPeroxide',
    label: 'Do you have an allergy to benzyl peroxide?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'yes', value: 'Yes' },
        { key: 'no', value: 'No' }
      ]
    },
    extras: { mdiQuestionId: '052b45d7-349e-4302-851e-9a1f9967821f' }
  },
  {
    field: 'mdiKPV_lastTimePersonMedicalEvaluation',
    label: 'When was the last time you had an in-person medical evaluation?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'less_than_a_year_ago', value: 'Less than a year ago' },
        { key: 'o_1_2_years_ago', value: '1-2 years ago' },
        { key: 'more_than_2_years_ago', value: 'More than 2 years ago' }
      ]
    },
    extras: { mdiQuestionId: '62616fa6-3c97-40f7-98a7-3087d59ac2ee' }
  },
  {
    field: 'mdiKPV_confirmUnderstandContactDoctorQuestions',
    label:
      'Please confirm the following: I understand and will contact my doctor if I have any questions',
    type: 'info',
    subLabel:
      'I understand that this peptide therapy is for use as a subcutaneous injection. I understand I will have to draw up and administer this injection myself. I understand that administering incorrectly or the wrong amount of this peptide therapy may cause serious side effects. I agree that I will reach out to my doctor prior to administering if I have any questions so that I can do it correctly\n\nType your full legal name below:',
    answer: {
      type: 'text',
      name: 'mdiKPV_confirmUnderstandContactDoctorQuestions'
    },
    extras: { mdiQuestionId: '513aa918-8a5f-4ac6-8df6-6755e6adea4c' }
  },
  {
    field: 'mdiKPV_firstMessageDoctor',
    label: 'This is your first message to your doctor.',
    type: 'info',
    subLabel:
      'Feel free to introduce yourself, ask any questions, or list any concerns you may have.',
    answer: { type: 'text', name: 'mdiKPV_firstMessageDoctor', rows: 4 },
    extras: { mdiQuestionId: '8f77ea66-d8f8-43c5-a2ce-c2d955957865' }
  },
  {
    field: 'mdiKPV_complete',
    label:
      'Thank you for completing this questionnaire, please select "Finish" to submit',
    type: 'info',
    isLast: true,
    answer: {},
    extras: { sendToBeluga: false, sendToMdi: false }
  }
] as const;

export type mdiKPVAnswerField = Partial<
  QuestionAnswerMap<typeof mdiKPVQuestions>
>;

export default mdiKPVQuestions;
